export const MODAL_NAMES = {
  RETURN_DETAILS: 'RETURN_DETAILS',
  MOBILE_FILTER: 'MOBILE_FILTER',
}
